import moment from 'moment'

export function formatTime(dateTime: Date | string): string {
  return new Date(dateTime.toString() + 'Z').toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  })
}

export function formatTimeMoment(time?: string): string | undefined {
  if (!time) {
    return undefined
  }

  return moment(`${moment().format('MM/DD/yyyy')} ${time}`).format('h:mm a')
}
